import apiClient from "./client";

export const getAdminSectors = async () => {
  const response = await apiClient.get("/sectors/admin");
  return response.data;
};

export const createAdminSector = async (payload) => {
  const response = await apiClient.post("/sectors/admin", payload);
  return response.data;
};

export const updateAdminSector = async ({ id, payload }) => {
  const response = await apiClient.put(`/sectors/admin/${id}`, payload);
  return response.data;
};

/** Save all language variants of a sector (grouped by slug) in one request. */
export const saveAdminSectorAllLanguages = async (payload) => {
  const response = await apiClient.post("/sectors/admin/save", payload);
  return response.data;
};

export const deleteAdminSector = async ({ id }) => {
  await apiClient.delete(`/sectors/admin/${id}`);
};

export const uploadAdminSectorMainImage = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/sectors/admin/${id}/main-image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteAdminSectorMainImage = async ({ id }) => {
  const response = await apiClient.delete(`/sectors/admin/${id}/main-image`);
  return response.data;
};

export const uploadAdminSectorProjectImage = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/sectors/admin/${id}/project-image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteAdminSectorProjectImage = async ({ id }) => {
  const response = await apiClient.delete(`/sectors/admin/${id}/project-image`);
  return response.data;
};

export const uploadAdminSectorGalleryImage = async ({ id, file }) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.post(`/sectors/admin/${id}/gallery-images`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const deleteAdminSectorGalleryImage = async ({ id, imageId }) => {
  const response = await apiClient.delete(`/sectors/admin/${id}/gallery-images/${imageId}`);
  return response.data;
};
